<!-- warn message modal definition -->

<div id="warnModal" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="with-icon error">
          <i class="fa fa-exclamation-triangle"></i>
          <p [innerHTML]="translateSrc | translate"></p>
        </div>
      </div>
      <div class="modal-footer">
      <div class="col-lg-4 form-group">
      </div>
      <div class="col-12 col-lg-4 mb-3">
          <button id="warnConfirmBtn" type="button" class="btn w-100 btn-primary" translate>MODAL.BUTTON_OK</button>
        </div>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->